import Main from './Main'
import Lista from './components/Patios'
import Novo from './components/NovoPatio'

export default [
  {
    path: 'patios',
    name: 'config.patios',
    component: Main,
    redirect: { name: 'config.patios.list' },
    children: [
      {
        path: '/',
        name: 'config.patios.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.patios.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.patios.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/configuracoes/patios/routes.js